import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';

import LoadingSpinner from 'components/LoadingSpinner';
import ErrorDialog from 'components/ErrorDialog';
import useStores from 'hooks/useStore';
import useLocalStorage from 'hooks/useLocalStorage';
import { useLocation } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';

import { StyledContainer, StyledContent } from './styles';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Container = observer(({ children, ...props }) => {
  const { UIStore } = useStores();
  const { loading, showError } = UIStore;

  const query = useQuery();

  const [isNativeView, setIsNativeView] = useLocalStorage('isNativeView', false);

  useEffect(() => {
    if (query.get('isNative')) {
      setIsNativeView(true);
    }
  }, []);

  return (
    <StyledContainer {...props}>
      {!window.ReactNativeWebView && <Header /> }
      <StyledContent>
        {children}
      </StyledContent>
      {!window.ReactNativeWebView && <Footer /> }
      {loading && <LoadingSpinner />}
      {showError && !loading && <ErrorDialog />}
    </StyledContainer>
  );
});

Container.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Container;
